module.exports = __webpack_public_path__ + "img/chengyun11.06ddfb3a.png";